import replaceItem from './replaceItem';

export const status = {
  FILE_SELECTED: 'FILE_SELECTED',
  UPLOADING: 'UPLOADING',
  UPLOADED: 'UPLOADED',
  NOTUPLOADED: 'NOTUPLOADED',
  DELETE_CLICKED: 'DELETE_CLICKED',
  DELETING: 'DELETING',
  NOTDELETED: 'NOTDELETED',
  REMOVE: 'REMOVE',
};

const uploading = (state, value) => {
  const { queueId, name } = value;
  return replaceItem(state, 'queueId', queueId, {
    queueId,
    loading: true,
    name,
    message: '',
    canRemove: false,
  });
};

const uploaded = (state, value) => {
  const { queueId, id, url } = value;
  return replaceItem(state, 'queueId', queueId, {
    url,
    id,
    loading: false,
    canRemove: false,
  });
};

const notUploaded = (state, value) => {
  const { queueId, message } = value;
  return replaceItem(state, 'queueId', queueId, {
    loading: false,
    message,
    canRemove: true,
  });
};

const deleting = (state, value) => {
  const { queueId } = value;
  return replaceItem(state, 'queueId', queueId, {
    loading: true,
    canRemove: false,
  });
};

const notDeleted = (state, value) => {
  const { queueId, message } = value;
  return replaceItem(state, 'queueId', queueId, {
    loading: false,
    canRemove: false,
    message,
  });
};

const remove = (state, value) => {
  const { queueId } = value;
  return state.reduce(
    (list, item) => (item.queueId === queueId ? list : [...list, item]),
    []
  );
};

export const reducer = (state, action) => {
  const { type, value } = action;
  switch (type) {
    case status.UPLOADING:
      return uploading(state, value);
    case status.UPLOADED:
      return uploaded(state, value);
    case status.NOTUPLOADED:
      return notUploaded(state, value);
    case status.DELETING:
      return deleting(state, value);
    case status.NOTDELETED:
      return notDeleted(state, value);
    case status.REMOVE:
      return remove(state, value);
    default:
      throw new Error(type + ' has no reducer');
  }
};

export const initialState = {};
